import React, {useEffect, useRef} from "react";

function DefaultCaptchaRenderer({
                                    onChange
                                }) {
    const iframe = useRef<HTMLIFrameElement | null>(null);
    useEffect(() => {
        window.addEventListener("message", (event) => {
            if (event.data?.type === "turnstile-resize") {
                // const iframe = document.getElementById("turnstileFrame");
                iframe.current!.style.width = event.data.width + "px";
                iframe.current!.style.height = event.data.height + "px";
            }

            if (event.data?.type === "turnstile-success") {
                onChange({
                    type:'turnstile',
                    value: event.data.token
                })
                // console.log("Turnstile token:", event.data.token);
            }
        });
    }, []);

    return <iframe ref={iframe} src={"https://creatives.goaffpro.com/7/vtbqpkty-turnstile-iframe.html"} style={{
        border: 'none',
        width: '100%',
        height: '100px',
    }} ></iframe>
}

export default DefaultCaptchaRenderer
